module.exports = __webpack_public_path__ + "img/choice.098b8ee5.png";